// @systeme: interface
// Les appels au modèle : combien, combien d'échecs, combien ça coûte, jour par jour.
import { useEffect, useState } from 'react';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import type { StatsAppels } from '@foyer/shared';
import { Chargement } from '../../composants/Chargement';
import { useMessages } from '../../composants/Messages';
import { api } from '../../lib/api';
import { formaterJourCourt } from '../../lib/dates';

export function Appels() {
  const { direErreur } = useMessages();
  const [stats, setStats] = useState<StatsAppels | undefined>();

  useEffect(() => {
    api.admin.appels().then(setStats).catch(direErreur);
  }, [direErreur]);

  if (!stats) return <Chargement />;
  const t = stats.trenteJours;
  return (
    <Stack spacing={2}>
      <Paper variant="outlined" sx={{ p: 2 }}>
        <Typography variant="h2" component="p">
          {t.appels} appel{t.appels > 1 ? 's' : ''} en trente jours
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {t.erreurs} en échec · {t.escalades} escalade{t.escalades > 1 ? 's' : ''} ·{' '}
          {t.cout.toFixed(2).replace('.', ',')} € estimés
        </Typography>
      </Paper>
      {stats.jours.length > 0 && (
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Jour</TableCell>
              <TableCell align="right">Appels</TableCell>
              <TableCell align="right">Échecs</TableCell>
              <TableCell align="right">Durée moy.</TableCell>
              <TableCell align="right">Coût</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {stats.jours.map((j) => (
              <TableRow key={j.jour}>
                <TableCell>{formaterJourCourt(j.jour)}</TableCell>
                <TableCell align="right">{j.appels}</TableCell>
                <TableCell align="right">{j.erreurs}</TableCell>
                <TableCell align="right">{j.dureeMoyenneMs} ms</TableCell>
                <TableCell align="right">{j.cout.toFixed(4)} €</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </Stack>
  );
}
